// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-footer-copy{display:block;padding:20px;font-size:var(--font-size-xs);line-height:1;text-align:center;background:#fff}", ""]);
// Exports
module.exports = exports;
